import { createTheme, styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { DataGrid } from "@mui/x-data-grid";
import { Slider, Pagination, ToggleButton, Button } from "@mui/material";

export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  border: 0,
  WebkitFontSmoothing: "auto",
  backgroundColor: "var(--bkgsecondary)",
  color: "var(--text-color)",
  letterSpacing: "normal",
  padding: "1%",
  overflow: "normal",
  "& .MuiDataGrid-columnHeaders": {
    margin: "2px 0 4px 0",
    padding: "0.5rem"
  },
  "& .MuiDataGrid-columnsContainer": {
    backgroundColor: theme.palette.mode === "light" ? "#fafafa" : "#1d1d1d",
  },
  "& .MuiDataGrid-iconSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
    border: 0,
    whiteSpace: "normal",
    "&:focus-within": {
      outline: "none",
    },
  },
  "& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell": {
    borderBottom: 0,
  },
  "& .MuiDataGrid-cell": {
    color: "var(--textsecondary-color)",
    minHeight: "auto !important",
    height: "auto !important",
    maxHeight: "none !important",
    text: "wrap"
  },
  "& .MuiPaginationItem-root": {
    borderRadius: 0,
    color: "var(--textsecondary-color)",
  },
  "& .MuiDataGrid-row": {
    cursor: "pointer",
    padding: "0.5rem",
    height: "auto !important",
    maxHeight: "none !important",
    pointerEvents: "auto",
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  "& .MuiDataGrid-virtualScroller": {
    overflow: "auto !important",
    overflowX: "hidden !important"
  },
  "& .MuiDataGrid-footerContainer": {
    justifyContent: "center",
    margin: "2px 0",
    border: 0,
    "& p": {
      margin: "auto",
      color: "var(--textsecondary-color)",
    },
    "& div": {
      color: "var(--textsecondary-color)",
      filter: "invert(100) !important",
    },
  },
}));

export const StyledGridOverlay = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  stickyHeader: "true",
  "& .ant-empty-img-1": {
    fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
  },
  "& .ant-empty-img-2": {
    fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
  },
  "& .ant-empty-img-3": {
    fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
  },
  "& .ant-empty-img-4": {
    fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
  },
  "& .ant-empty-img-5": {
    fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
    fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
  },
}));

export const theme = createTheme({
  palette: {
    primary: {
      main: '#326295',
    },
    info: {
      main: '#4994CE',
    },
    secondary: {
      main: "#F09316",
    },
    flag: {
      main: "#FFBE45"
    },
    success: {
      main: "#00693C"
    },
    error: {
      main: '#953432',
    }
  },
});
